import styled from 'styled-components';

import { Button, Typography } from '@mui/material';

import { colors } from '../../theme';

interface RoundButtonProps {
    secondary: string;
    buttoncolor: any;
}

interface DefaultButtonProps {
    buttoncolor: any;
}

const GlobalButton = (props: any) => {
    const { text, buttoncolor } = props;

    return (
        <>
            {props.variant === 'round' ? (
                <RoundButton {...props}>
                    <Typography variant="body2" sx={{ lineHeight: 0 }}>
                        {text}
                    </Typography>
                </RoundButton>
            ) : (
                <StyledButton {...props} buttoncolor={buttoncolor}>
                    <Typography variant="h5" sx={{ lineHeight: 0 }}>
                        {text}
                    </Typography>
                </StyledButton>
            )}
        </>
    );
};

export default GlobalButton;

const StyledButton = styled(Button)<DefaultButtonProps>`
    && {
        text-transform: capitalize;
        box-shadow: none;
        min-height: 30px;
        border-radius: 0px;
        padding: 0px 30px;

        &:hover {
            box-shadow: none;
        }

        svg {
            width: 15px;
            height: auto;

            path {
                fill: ${colors.white};
            }
        }

        &.MuiButton-outlined {
            background-color: ${colors.white};
            border-color: ${(props) => (props.buttoncolor ? props.buttoncolor : colors.blue.main)};

            &:hover {
                background-color: ${colors.blue.light};
            }

            svg {
                path {
                    fill: ${colors.blue.main};
                }
            }
            &.Mui-disabled {
                opacity: 0.4;
                background-color: ${colors.white};
                border-color: ${(props) => (props.buttoncolor ? props.buttoncolor : colors.blue.main)};
                color: ${(props) => (props.buttoncolor ? props.buttoncolor : colors.blue.main)};
            }
            ${(props) =>
                props.buttoncolor && {
                    borderColor: props.buttoncolor.main,
                    color: props.buttoncolor.main,
                    '&:hover': {
                        backgroundColor: props.buttoncolor.light,
                    },
                    svg: {
                        path: {
                            fill: props.buttoncolor.main,
                        },
                    },
                }}
        }

        &.MuiButton-contained {
            &.Mui-disabled {
                color: ${colors.white};
                background-color: ${(props) => (props.buttoncolor ? props.buttoncolor : colors.blue.main)};
                border: none;
                opacity: 0.4;
            }
        }

        ${(props) =>
            props.buttoncolor && {
                backgroundColor: props.buttoncolor.main,
                color: colors.white,
                '&:hover': {
                    backgroundColor: props.buttoncolor.hover,
                },
                svg: {
                    path: {
                        fill: colors.white,
                    },
                },
            }}
    }
`;

const RoundButton = styled(Button)<RoundButtonProps>`
    && {
        text-transform: capitalize;
        box-shadow: none;
        min-height: 30px;
        padding: 0px 10px;
        background-color: ${(props) => (props.color ? props.color : colors.blue.main)};
        color: ${colors.white};

        &:hover {
            box-shadow: none;
            background-color: ${colors.blue.dark};
        }

        &.Mui-disabled {
            color: ${colors.blue.disabled};
            background-color: ${colors.grey.light};

            svg {
                path {
                    fill: ${colors.blue.disabled};
                }
            }
        }

        svg {
            width: 15px;
            height: auto;

            path {
                fill: ${colors.white};
            }
        }

        ${(props) =>
            props.secondary === 'true' &&
            (props.buttoncolor
                ? {
                      color: props.buttoncolor.main,
                      backgroundColor: props.buttoncolor.light,
                      '&:hover': {
                          color: props.buttoncolor.main,
                          backgroundColor: props.buttoncolor.light,
                          opacity: 0.8,
                      },
                      '&.Mui-disabled': {
                          color: props.buttoncolor.main,
                          backgroundColor: props.buttoncolor.light,
                      },
                      svg: {
                          path: {
                              fill: props.buttoncolor.main,
                          },
                      },
                  }
                : {
                      color: colors.blue.main,
                      backgroundColor: colors.blue.light,
                      '&:hover': {
                          backgroundColor: colors.blue.hover,
                      },
                      '&.Mui-disabled': {
                          color: colors.blue.main,
                          backgroundColor: colors.blue.light,
                          opacity: '0.5',
                          svg: {
                              path: {
                                  fill: colors.blue.main,
                              },
                          },
                      },
                      svg: {
                          path: {
                              fill: colors.blue.main,
                          },
                      },
                  })}

        ${(props) =>
            props.secondary !== 'true' &&
            props.buttoncolor && {
                backgroundColor: props.buttoncolor.main,
                color: colors.white,
                '&:hover': {
                    backgroundColor: props.buttoncolor.hover,
                },
                svg: {
                    path: {
                        fill: colors.white,
                    },
                },
            }}
    }
`;
